<template>
  <div class="main-view" v-loading.body="loading">
    <el-card class="searchCard" shadow="never">
      <!-- 筛选 -->
      <el-col>
        <el-form inline class="inline-form">
          <el-form-item label="补差时间">
            <el-date-picker
              v-model="repairTime"
              class="el_date_picker"
              type="daterange"
              align="left"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="交易订单号">
            <el-input class="search-input" v-model="orderId" placeholder="交易订单号"></el-input>
          </el-form-item>
          <el-form-item label="差错类型">
            <el-select class="search-input" v-model="errorType" clearable>
              <el-option label="短款" value="1"></el-option>
              <el-option label="长款" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="处理状态">
            <el-select class="search-input" v-model="serialStatus" clearable>
              <el-option label="待处理" value="0"></el-option>
              <el-option label="处理中" value="1"></el-option>
              <el-option label="已处理" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <auth-button opt="search" :plain="true" icon="el-icon-search" @click.native="searchClick" label="查询"></auth-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-card>
    <el-card class="tableCard" shadow="never">
      <el-table
        stripe
        style="width:100%;"
        v-loading="tableLoading"
        :data="merchantErrorTicketList"
        :header-cell-style="{background:'#FAFAFA'}">
        <el-table-column
          type="index"
          label="序号"
          align="center"
          width="60">
        </el-table-column>
        <el-table-column
          prop="fCreateTime"
          label="补差时间"
          align="center"
          min-width="180">
        </el-table-column>
        <el-table-column
          prop="transTime"
          label="交易时间"
          align="center"
          min-width="180">
        </el-table-column>
        <el-table-column
          prop="fOrderId"
          label="交易单号"
          align="center"
          min-width="180">
        </el-table-column>
        <el-table-column
          prop="fMerchantId"
          label="商户编号"
          align="center"
          min-width="180">
        </el-table-column>
        <el-table-column
          prop="merchantName"
          label="商户简称"
          align="center"
          min-width="180">
        </el-table-column>
        <el-table-column
          prop="payTypeStr"
          label="交易类型"
          align="center"
          min-width="180">
        </el-table-column>
        <el-table-column
          prop="payStatusStr"
          label="交易状态"
          align="center"
          min-width="180">
        </el-table-column>
        <el-table-column
          prop="amountStr"
          label="应结订单金额"
          align="center"
          min-width="180">
          <template slot-scope="scope">
            <div>{{ scope.row.amountStr || '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="merchantFeeStr"
          label="商户费率(%)"
          align="center"
          min-width="180">
          <template slot-scope="scope">
            <div>{{ scope.row.merchantFeeStr || '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="merchantFeeAmountStr"
          label="手续费总额"
          align="center"
          min-width="180">
          <template slot-scope="scope">
            <div>{{ scope.row.merchantFeeAmountStr || '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="settleAmountStr"
          label="结算金额"
          align="center"
          min-width="180">
          <template slot-scope="scope">
            <div>{{ scope.row.settleAmountStr || '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="errorTypeStr"
          label="差错类型"
          align="center"
          min-width="180">
          <template slot-scope="scope">
            <div>{{ scope.row.errorTypeStr || '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="serialStatusStr"
          label="处理状态"
          align="center"
          min-width="180">
          <template slot-scope="scope">
            <div>{{ scope.row.serialStatusStr || '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          align="center"
          min-width="180">
        </el-table-column>
      </el-table>
    </el-card>
    <el-col :span="24" class="btm-action">
      <el-pagination
        v-if="paginations.count > 0"
        class="pagination"
        :page-size="paginations.pageSize"
        layout="total, prev, pager, next, jumper"
        :total="paginations.count"
        :current-page="paginations.pageNo"
        @current-change="onChangeCurrentPage">
      </el-pagination>
    </el-col>
  </div>
</template>

<script>
import qs from 'qs'
import { parseTime } from '@/utils/formatTime'
import { listMerchantErrorTicket, exportMerchantErrorTicket, getAllSubMerchantNames } from '@/api/settle.js'

export default {
  name: 'TradeErrorTicket',
  data () {
    const todayStr = parseTime(new Date(), '{y}-{m}-{d}')
    const toadyZero = new Date(new Date().getTime() - 1000 * 60 * 60 * 24)
    const todayZeroStr = parseTime(toadyZero, '{y}-{m}-{d}')

    return {
      loading: false,
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6
        },
        shortcuts: [{
          text: '昨天',
          onClick (picker) {
            // 精确到日
            const start = new Date()
            const end = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24)
            end.setTime(end.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      // 需要给分页组件传的信息
      paginations: {
        pageNo: 1,
        count: 0,
        pageSize: 10
      },
      // 搜索表单信息
      searchInfo: {
        startTime: '',
        endTime: '',
        orderId: '',
        merchantId: '',
        // agentId: '',
        errorType: '',
        serialStatus: ''
      },
      repairTime: [todayZeroStr, todayStr],
      orderId: '',
      merchantId: '',
      // agentId: '',
      errorType: '',
      serialStatus: '',
      tableLoading: false,
      selectLoading: false,
      exportButtonLoading: false,
      // subMerchantNamesList: [],//商户编号可选列表
      merchantErrorTicketList: []// 数据列表
    }
  },
  mounted () {
    // if (this.roleName !== 'operator') {
    //   this.getSubAgentInfo()
    //   // this.querySaleList()
    // }
    this.getDefaultData()
  },
  methods: {
    /**
       * @description 初始加载数据方法
       */
    async getDefaultData () {
      // this.loading = true;
      await this.getAllSubMerchantNames()
      await this.searchClick()
      this.loading = false
    },
    /**
       * 改变当前页事件
       * @param {number} page 当前页码
       */
    onChangeCurrentPage (page) {
      this.paginations.pageNo = page
      this.searchClick(true)
    },
    /**
       * 筛选查询按钮点击
       */
    searchClick (noReset) {
      console.log('查询点击')
      if (!this.merchantId) {
        this.$message({
          message: '商户编号有误！',
          type: 'warning'
        })
        return
      }
      this.setSearchInfoParams(noReset)
      this.listMerchantErrorTicket()
    },
    /**
       * 导出按钮点击
       */
    exportClick () {
      console.log('导出点击')
      if (!this.merchantId) {
        this.$message({
          message: '请先输入商户编号',
          type: 'warning'
        })
        return
      }
      this.setSearchInfoParams(true)
      const startDate = new Date(this.searchInfo.startTime)
      const endDate = new Date(this.searchInfo.endTime)
      if (!this.searchInfo.startTime || !this.searchInfo.endTime || endDate.getTime() - startDate.getTime() > 3600 * 1000 * 24 * 30) {
        this.$message({
          message: '请筛选1个月内的数据进行导出',
          type: 'error'
        })
        return
      }
      this.exportMerchantErrorTicket()
    },
    /**
       * 组装筛选参数
       */
    setSearchInfoParams (noReset) {
      this.searchInfo.startTime = this.repairTime && this.repairTime[0] ? this.repairTime[0] : ''
      this.searchInfo.endTime = this.repairTime && this.repairTime[1] ? this.repairTime[1] : ''
      this.searchInfo.orderId = this.orderId || ''
      this.searchInfo.merchantId = this.merchantId || ''
      // this.searchInfo.agentId = this.agentId || ''
      this.searchInfo.errorType = this.errorType || ''
      this.searchInfo.serialStatus = this.serialStatus || ''
      this.formatParams(this.searchInfo)
      if (noReset !== true) {
        this.paginations.pageNo = 1
        this.paginations.count = 0
      }
      this.searchInfo = Object.assign(this.searchInfo, this.paginations)
    },
    /**
       * 删除提交参数中的空字段
       */
    formatParams (params) {
      for (const key in params) {
        // eslint-disable-next-line no-prototype-builtins
        if (params.hasOwnProperty(key) && !params[key] && params[key] !== 0) {
          delete params[key]
        }
      }
    },
    // /**
    //  * 商户选择筛选商户方法
    //  */
    // handleMerchantInfoFilter(queryString) {
    //   if (queryString) {
    //     this.subMerchantNamesList = this.subMerchantNamesList_back.filter(item => {
    //       return item.code.toLowerCase().includes(queryString.toLowerCase()) || item.name.toLowerCase().includes(queryString.toLowerCase())
    //     })
    //   } else {
    //     this.subMerchantNamesList = this.subMerchantNamesList_back
    //   }
    // },

    /**
       * 获取交易订单差错处理列表
       */
    listMerchantErrorTicket () {
      this.loading = true
      const params = qs.stringify(this.searchInfo)
      console.log(params)
      listMerchantErrorTicket(params).then(response => {
        this.loading = false
        console.log('listMerchantErrorTicket response:', response)
        if (response.error_code === '0') {
          this.merchantErrorTicketList = response.data.list
          this.paginations.count = response.data.totalCount
        } else {
          this.$message({
            message: response.result_msg,
            type: 'error'
          })
        }
      })
    },
    /**
       * 交易订单差错处理导出
       */
    exportMerchantErrorTicket () {
      this.exportButtonLoading = true
      const params = qs.stringify(this.searchInfo)
      console.log(params)
      exportMerchantErrorTicket(params).then(response => {
        this.exportButtonLoading = false
        console.log('profitRepairExport调用')
        // 弹出下载框
        const url = window.URL.createObjectURL(new Blob([response]))
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', '差错处理.xlsx')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }, {
        axios_opts: {
          responseType: 'blob'
        }
      })
    },

    /**
       * 获取商户编号下拉列表
       */
    getAllSubMerchantNames () {
      return new Promise((resolve, reject) => {
        getAllSubMerchantNames('').then(response => {
          console.log('getAllSubMerchantNames response:', response)
          if (response.error_code === '0') {
            this.subMerchantNamesList = response.data
            this.subMerchantNamesList_back = [...this.subMerchantNamesList]
            this.merchantId = this.subMerchantNamesList[0].code
            resolve()
          } else {
            this.loading = false
            this.$message({
              message: response.error_msg,
              type: 'error'
            })
            resolve(false)
          }
        }).catch((e) => {
          this.loading = false
          reject(e)
        })
      })
    }
  },
  computed: {
    roleName () {
      return this.$store.getters.roleName
    }
  },
  filters: {
    formatPayType (value) {
      switch (value) {
        case 1:
          return 'pos刷卡'
        case 2:
          return '微信支付'
        case 3:
          return '支付宝支付'
        case 4:
          return '实名支付'
        case 5:
          return '快捷支付'
        case 6:
          return '银联扫码支付'
        case 7:
          return 'QQ支付'
        case 8:
          return '建行龙支付'
        case 9:
          return '银联支付'
        case 15:
          return 'apple支付'
        default:
          return '未知'
      }
    },
    formatStatus (value) {
      switch (value) {
        case 0:
          return '未入账'
        case 1:
          return '已入账'
        default:
          return '未知'
      }
    }
  }
}
</script>

<style scoped>
  .main-view {
    padding-left: 16px;
  }
  .search-input {
    width: 160px;
  }
  .btm-action {
    margin: 20px 0;
    text-align: center;
  }
  .invoice-dialog-form-item {
    width: 260px;
  }
</style>
